// Helpers for picking the localized variant of a content field (name_ar / description_ar / etc.)
export const localized = (obj, field, lang) => {
  if (!obj) return '';
  if (lang === 'ar') {
    const arField = `${field}_ar`;
    if (obj[arField]) return obj[arField];
  }
  return obj[field] || '';
};
